import React, { useState } from 'react';
import { TagIcon, CheckIcon, SparklesIcon } from 'lucide-react';
interface BundleDealsProps {
  product: {
    price: number;
  };
}
export function BundleDeals({
  product
}: BundleDealsProps) {
  const [selectedOption, setSelectedOption] = useState(1);
  const bundleOptions = [{
    pieces: 1,
    pricePerPiece: product.price,
    totalPrice: product.price,
    discount: 0,
    label: 'Standard price',
    color: 'from-gray-100 to-gray-50',
    iconBg: 'bg-gray-100',
    iconColor: 'text-gray-600',
    badgeBg: 'bg-gray-500'
  }, {
    pieces: 3,
    pricePerPiece: product.price * 0.9,
    totalPrice: product.price * 0.9 * 3,
    discount: 10,
    label: 'SAVE 10%',
    color: 'from-blue-100 to-blue-50',
    iconBg: 'bg-gradient-to-br from-blue-500 to-blue-600',
    iconColor: 'text-white',
    badgeBg: 'bg-gradient-to-r from-orange-500 to-orange-600',
    popular: true
  }, {
    pieces: 5,
    pricePerPiece: product.price * 0.85,
    totalPrice: product.price * 0.85 * 5,
    discount: 15,
    label: 'SAVE 15%',
    color: 'from-green-100 to-green-50',
    iconBg: 'bg-gradient-to-br from-green-500 to-green-600',
    iconColor: 'text-white',
    badgeBg: 'bg-gradient-to-r from-red-500 to-red-600',
    bestValue: true
  }];
  return <div className="bg-white rounded-2xl border-2 border-gray-200 overflow-hidden" data-id="element-4912" data-mp="3dbk0nbq4set4">
      {/* Header with gradient and sparkle effect */}
      <div className="bg-gradient-to-r from-[#1E2B55] via-[#2a3a6f] to-[#1E2B55] p-4 relative overflow-hidden" data-id="element-4913" data-mp="2kmctxpgiwiws">
        {/* Decorative circles */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-5 rounded-full -mr-16 -mt-16" data-id="element-4914" data-mp="2ynfhk6n6219t"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white opacity-5 rounded-full -ml-12 -mb-12" data-id="element-4915" data-mp="2uizdmax453x8"></div>
        <div className="flex items-center justify-between relative z-10" data-id="element-4916" data-mp="dxhr0522tg7i">
          <div className="flex items-center gap-2 text-white" data-id="element-4917" data-mp="9tiavnkpkjeo">
            <div className="bg-white bg-opacity-20 p-2 rounded-lg" data-id="element-4918" data-mp="32pbiopf4tdyk">
              <TagIcon className="w-5 h-5" data-id="element-4919" data-mp="37nmsj05ffogs" />
            </div>
            <div data-id="element-4920" data-mp="37m1zjeyrgdl1">
              <h3 className="text-base font-bold" data-id="element-4921" data-mp="37ppri9ok4rxn">Bundle & Save</h3>
              <p className="text-xs text-blue-100" data-id="element-4922" data-mp="3co13apyexcii">Up to 15% off</p>
            </div>
          </div>
          <SparklesIcon className="w-5 h-5 text-yellow-300 animate-pulse" data-id="element-4923" data-mp="3gn05w3wo8x6s" />
        </div>
      </div>
      {/* Content */}
      <div className="p-4 bg-gradient-to-b from-gray-50 to-white" data-id="element-4924" data-mp="2jzvg7wjvzbfi">
        <div className="space-y-2.5" data-id="element-4925" data-mp="2oy6qg8e3fny9">
          {bundleOptions.map(option => <button key={option.pieces} onClick={() => setSelectedOption(option.pieces)} className={`w-full border-2 rounded-xl p-3 transition-all duration-300 transform hover:scale-[1.02] relative overflow-hidden ${selectedOption === option.pieces ? 'border-[#1E2B55] bg-gradient-to-r from-blue-50 to-indigo-50' : 'border-gray-200 hover:border-gray-300 bg-white hover:shadow-sm'}`} data-id="element-4926" data-mp="2sygvniu2aac2">
              <div className="flex items-center gap-3" data-id="element-4927" data-mp="1xou36oky7n4k">
                {/* Icon with quantity badge */}
                <div className="relative flex-shrink-0" data-id="element-4928" data-mp="1srbv10er9bxm">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center shadow-sm ${option.iconBg}`} data-id="element-4929" data-mp="1oo5m1l09d6ng">
                    <svg className={`w-6 h-6 ${option.iconColor}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4930" data-mp="1js6xnxexjon1">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" data-id="element-4931" data-mp="1506dmgt62bl7" />
                    </svg>
                  </div>
                  {option.pieces > 1 && <div className={`absolute -top-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold text-white shadow-sm ${option.pieces === 3 ? 'bg-blue-600' : 'bg-green-600'}`} data-id="element-4932" data-mp="2r3fzqz0ey391">
                      {option.pieces}
                    </div>}
                </div>
                {/* Details */}
                <div className="flex-1 text-left" data-id="element-4933" data-mp="2mad50njwgnr9">
                  <div className="flex items-center justify-between mb-1.5" data-id="element-4934" data-mp="28bvmr5crk3gq">
                    <span className="font-bold text-gray-900 text-base" data-id="element-4935" data-mp="2cf1oq0suf8he">
                      {option.pieces} Piece{option.pieces > 1 ? 's' : ''}
                    </span>
                    {option.discount > 0 && <span className={`${option.badgeBg} text-white text-xs font-bold px-2.5 py-0.5 rounded-full shadow-sm`} data-id="element-4936" data-mp="23emziqcrd98m">
                        {option.label}
                      </span>}
                  </div>
                  <div className="flex items-center justify-between" data-id="element-4937" data-mp="1m3q79klrh1tp">
                    <span className="text-xs text-gray-600 font-medium" data-id="element-4938" data-mp="1h5g5us9g14zn">
                      {option.pieces === 1 ? option.label : `SAR ${option.pricePerPiece.toFixed(2)}/piece`}
                    </span>
                    <div className="text-right" data-id="element-4939" data-mp="1r21gpu859abe">
                      <span className="text-lg font-bold text-red-600" data-id="element-4940" data-mp="24ur2bxjrgd7z">
                        SAR {option.totalPrice.toFixed(2)}
                      </span>
                      {option.discount > 0 && <div className="text-xs text-gray-500 line-through" data-id="element-4941" data-mp="2etq9fbovo0sv">
                          SAR {(product.price * option.pieces).toFixed(2)}
                        </div>}
                    </div>
                  </div>
                </div>
                {/* Checkmark */}
                <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 shadow-sm ${selectedOption === option.pieces ? 'bg-gradient-to-r from-[#1E2B55] to-[#2a3a6f] scale-110' : 'bg-gray-200'}`} data-id="element-4942" data-mp="fgunvds8p53e">
                  {selectedOption === option.pieces && <CheckIcon className="w-4 h-4 text-white" data-id="element-4943" data-mp="1e6zkf3le7pk4" />}
                </div>
              </div>
            </button>)}
        </div>
      </div>
    </div>;
}